import { Button } from "@/components/ui/button";

interface SlippageSelectorProps {
  slippageTolerance: number;
  onSlippageChange: (tolerance: number) => void;
}

const SlippageSelector = ({ slippageTolerance, onSlippageChange }: SlippageSelectorProps) => {
  return (
    <div>
      <label className="text-sm text-muted-foreground">Slippage Tolerance</label>
      <div className="flex gap-2 mt-1">
        {[0.005, 0.01, 0.02].map((tolerance) => (
          <Button
            key={tolerance}
            variant={slippageTolerance === tolerance ? "default" : "outline"}
            size="sm"
            onClick={() => onSlippageChange(tolerance)}
          >
            {(tolerance * 100).toFixed(1)}%
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SlippageSelector;